import addIcon from "assets/icons/add.svg"
import { CMSButton } from "components/common/button"
import React, { useState } from "react"
import ReactDOM from "react-dom"

import ServiceRequestModal from "./ServiceRequestModal"

export default function CreateServiceRequestButton() {
  const [show, setShow] = useState(false)

  return (
    <>
      {ReactDOM.createPortal(
        <ServiceRequestModal show={show} setShow={setShow} />,
        document.getElementById("serv-req-modal")
      )}
      <CMSButton
        dataTut="service-request-btn"
        onClick={() => setShow(true)}
        type="primary"
      >
        <img src={addIcon} alt="add" className="add-icon" />
        Service Request
      </CMSButton>
    </>
  )
}
